import { gql } from "urql";

export const LOGIN_ADMIN: any = gql(`
    mutation loginAdmin($loginUserInput: LoginUserInput!) {
        loginAdmin(loginUserInput: $loginUserInput) {
            user {
                _id
                name
            }
            authToken
        }
    }
`)

export const GET_OAUTH_TOKEN: any = gql(`
    mutation getOAuthToken($userId: String) {
        getOAuthToken(userId: $userId)
    }
`)